import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M15.436 9.14a.75.75 0 0 1 .174 1.046l-3.75 5.25a.75.75 0 0 1-1.14.094l-2.25-2.25a.75.75 0 0 1 1.06-1.06l1.624 1.624 3.236-4.53a.75.75 0 0 1 1.046-.174"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M11.484 2.17a.75.75 0 0 1 1.032 0 11.2 11.2 0 0 0 7.877 3.079.75.75 0 0 1 .722.516 12.7 12.7 0 0 1 .635 3.985c0 5.942-4.064 10.933-9.563 12.348a.75.75 0 0 1-.374 0C6.314 20.683 2.25 15.692 2.25 9.75c0-1.39.223-2.73.635-3.985a.75.75 0 0 1 .722-.516h.143c2.996 0 5.718-1.17 7.734-3.08M4.156 6.744A11.3 11.3 0 0 0 3.75 9.75c0 5.173 3.493 9.533 8.25 10.846 4.757-1.313 8.25-5.673 8.25-10.846 0-1.042-.142-2.05-.406-3.006A12.7 12.7 0 0 1 12 3.72a12.7 12.7 0 0 1-7.844 3.023",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }